export const CANCEL = "global.cancel";
export const SAVE = "activation.settings.action.save.text";
export const TOOLTIP_DISABLED_TEXT = "activation.settings.action.save.tooltip";
